import {gql} from 'apollo-angular';
import {baseResponseGraphqlField} from '../../../base.graphql';

export const citizenProviderSummaries = `
provider {
  id
  institutionUniqueId
  institutionName
  institutionShortform
  institutionPhysicalAddress
  institutionEmail
  institutionPostcode
  institutionWebsite
  institutionPhones
  institutionMapUrl
  institutionMinistry {
    id
    ministryUniqueId
    ministryName
  }
  institutionSector {
    id
    sectorUniqueId
    sectorName
    sectorIcon
  }
}
serviceCounts

`;

export const GET_CITIZEN_PROVIDER_SUMMARIES = gql`
query citizenGetProvidersSummaries{
    citizenGetProvidersSummaries{
    ${baseResponseGraphqlField}
    data {
      ${citizenProviderSummaries}
    }
  }
}
`;
